"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _removeLanguageFromPathname = require("./removeLanguageFromPathname");
Object.keys(_removeLanguageFromPathname).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _removeLanguageFromPathname[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _removeLanguageFromPathname[key];
    }
  });
});
